import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { cookieUtils } from '../_helpers/cookieUtils';

export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            if (localStorage.getItem('access_token')) {
                return <Component {...props} />
            } else {
              
                cookieUtils.setCookie('lastAttemptedRoute', props.location.pathname);
                return <Redirect to={{ 
                    pathname: '/login', 
                    state: { from: props.location } 
                }} />
            }
        }} />
    )
}


// WEBPACK FOOTER //
// ./src/_components/PrivateRoute.jsx